import { TrendingDown, AlertTriangle, CheckCircle2, ShieldAlert } from "lucide-react";

const GRADE_STYLE = {
  A: {
    badge: "bg-emerald-100 text-emerald-800 border-emerald-200",
    text: "text-emerald-800",
    label: "Excelente",
    Icon: CheckCircle2,
  },
  B: {
    badge: "bg-sky-100 text-sky-800 border-sky-200",
    text: "text-sky-800",
    label: "Bueno",
    Icon: CheckCircle2,
  },
  C: {
    badge: "bg-amber-100 text-amber-800 border-amber-200",
    text: "text-amber-800",
    label: "A vigilar",
    Icon: AlertTriangle,
  },
  D: {
    badge: "bg-red-100 text-red-800 border-red-200",
    text: "text-red-800",
    label: "Problemático",
    Icon: ShieldAlert,
  },
};

/**
 * Chip pequeño con la nota A/B/C/D del proveedor, basada en los pedidos
 * recibidos en los últimos 90 días (incidencias + completitud).
 *
 * Props:
 *   data: {grade, score, incident_rate, completeness_rate, orders_received}
 *   compact: boolean (si true, sólo muestra la nota; si false, incluye texto)
 */
export default function SupplierScorecardChip({ data, compact = false, testId }) {
  if (!data) return null;
  const style = GRADE_STYLE[data.grade] || GRADE_STYLE.C;
  const { Icon } = style;
  const incidentPct = Math.round((data.incident_rate || 0) * 100);
  const completenessPct = Math.round((data.completeness_rate || 0) * 100);

  if (compact) {
    return (
      <span
        title={`Nota ${data.grade} (${data.score}/100) · ${data.orders_received} pedidos · ${incidentPct}% incidencias · ${completenessPct}% completitud`}
        className={`inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-full border ${style.badge}`}
        data-testid={testId}
      >
        <Icon className="h-3 w-3" />
        Nota {data.grade}
      </span>
    );
  }

  return (
    <div
      className={`flex items-center gap-2 text-xs border rounded-lg px-2.5 py-1.5 ${style.badge}`}
      data-testid={testId}
    >
      <Icon className="h-3.5 w-3.5 shrink-0" />
      <div className="flex-1 min-w-0">
        <div className={`font-semibold ${style.text}`}>
          Nota {data.grade} · {data.score}/100
        </div>
        <div className="text-[11px] opacity-80">
          {data.orders_received} pedido{data.orders_received === 1 ? "" : "s"} · {incidentPct}% incidencias · {completenessPct}% completos
        </div>
      </div>
    </div>
  );
}

export { GRADE_STYLE };
